<template>
  <div>
    <h2>SEO-продвижение быстро и дешево? Будьте осторожны!</h2>

    <p>Уважаемые партнеры! Обращаем Ваше внимание, что в последнее время заметно активизировались недобросовестные поставщики услуг, в том числе в сфере SEO-продвижения. Как правило, они предлагают вывести Ваш сайт в ТОП поисковых систем за пару месяцев и несколько тысяч рублей, при этом активно очерняют Вашу SEO-компанию.</p>
    <p>Вы, наверное, периодически получаете звонки и письма с подобными предложениями... Представитель маленькой SEO-компании, или даже фрилансер, присылает уже сделанный псевдоаудит Вашего сайта, где «показано», как плохи Ваши дела и как плохо работает Ваша SEO-компания. Заметьте, такие «оптимизаторы» катастрофически мало говорят о своих достижениях.</p>
    <p>Чтобы уберечь не только Ваш сайт, но и бизнес от опасностей и проблем, необходимо грамотно оценить уровень SEO-компании и решить, достойна ли она Вашего внимания. И сделать это можно достаточно просто и быстро.</p>

    <h3>12 ПРИЗНАКОВ НАДЕЖНОЙ SEO-КОМПАНИИ</h3>

    <c-box class="signs">
      <div
        v-for="(sign, index) of signs"
        :key="index"
        class="sign"
      >
        <div class="sign-icon">
          <component :is="sign.icon" />
        </div>
        <div class="sign-content">
          <div class="sign-title">
            {{ sign.title }}
          </div>
          <div
            class="sign-text"
            v-html="sign.text"
          />
        </div>
        <div class="clearfix" />
      </div>
    </c-box>

    <p>Выбор подрядчика по продвижению – это всегда комплексная оценка рисков. Правильно оценить потенциального партнера действительно важно, так как на кону не только оперативное достижение Вашим сайтом позиций в ТОПе Яндекса и Google, но и безопасность бизнеса, отсутствие негативных последствий в виде банов и фильтров со стороны поисковых систем.</p>
  </div>
</template>

<script>
import CBox from '../../components/ui/CBox'

export default {
  name: 'Cheapseo',
  components: {
    CBox,
    IconEmail: () => import('../../../img/faq/cheapseo/email.svg?inline'),
    IconOffice: () => import('../../../img/faq/cheapseo/office.svg?inline'),
    IconCup: () => import('../../../img/faq/cheapseo/cup.svg?inline'),
    IconPeople: () => import('../../../img/faq/cheapseo/people.svg?inline'),
    IconRatings: () => import('../../../img/faq/cheapseo/ratings.svg?inline'),
    IconLetter: () => import('../../../img/faq/cheapseo/letter.svg?inline'),
    IconWallet: () => import('../../../img/faq/cheapseo/wallet.svg?inline'),
    IconMonitor: () => import('../../../img/faq/cheapseo/monitor.svg?inline'),
    IconChecklist: () => import('../../../img/faq/cheapseo/checklist.svg?inline'),
    IconCollaboration: () => import('../../../img/faq/cheapseo/collaboration.svg?inline'),
    IconCard: () => import('../../../img/faq/cheapseo/card.svg?inline'),
    IconLamp: () => import('../../../img/faq/cheapseo/lamp.svg?inline')
  },
  data () {
    return {
      signs: [
        {
          icon: 'IconEmail',
          title: 'Адрес домена в электронной почте контактного лица совпадает с адресом сайта SEO-компании',
          text: 'Надежные SEO-компании не используют бесплатные почтовые ящики, типа @mail.ru, @yandex.ru, @rambler.ru и так далее. Сотрудники серьезных фирм пишут письма только с корпоративного почтового домена, который не отличается от адреса сайта. Для Вас – это гарантия общения с представителем конкретной SEO-компании, отвечающим как за полученные от Вас сведения, так и за предоставленные данные и условия от имени SEO-компании.'
        },
        {
          icon: 'IconOffice',
          title: 'У SEO-компании есть офис и городской номер телефона для связи',
          text: 'Сотрудники надежной SEO-компании направляют Вам письма и оставляют визитки, в которых указан адрес и городской телефон офиса. Вы можете в любой момент проверить, работает ли там конкретный сотрудник.'
        },
        {
          icon: 'IconCup',
          title: 'SEO-компания существует более 7 лет',
          text: 'Чем дольше существует SEO-компания, тем она надежнее. О таких компаниях Вы всегда найдете много отзывов в открытых источниках информации и сможете составить собственное мнение. Возраст SEO-компании определяется просто – для этого достаточно посмотреть, сколько лет ее сайту. Проверить возраст любого домена Вы можете самостоятельно, например, на независимом ресурсе <a href="http://www.nic.ru/">www.nic.ru</a>.'
        },
        {
          icon: 'IconPeople',
          title: 'SEO-компания – это полноценная команда профессионалов!',
          text: 'Ключевое преимущество крупных SEO-компаний – большой штат профессионалов в каждой области интернет-продвижения. Повышение квалификации сотрудника в таких компаниях происходит в соответствии с профессиональной специализацией, что позволяет получить экспертов высочайшего класса. Четкое разделение обязанностей и прозрачные бизнес-процессы позволяют добиваться наилучших результатов для Клиентов.'
        },
        {
          icon: 'IconRatings',
          title: 'SEO-компания занимает достойные места в профессиональных рейтингах',
          text: 'Очевидный факт: достойная доверия компания, у которой есть весомые доказанные профессиональные достижения, будет принимать участие в независимых рейтингах и конкурсах, завоевывая награды и получая соответствующие знаки отличия. Наиболее авторитетные рейтинги в отрасли SEO-продвижения: «Рейтинг Рунета», «КтоПродвинул.ру» и «TOPSEOs».'
        },
        {
          icon: 'IconLetter',
          title: 'У SEO-компании много довольных Клиентов и официальных благодарственных писем',
          text: 'Множество Клиентов из разных областей, среди которых – крупные известные бренды, красноречиво свидетельствует о том, что SEO-компании доверяют! Это показатель наличия опыта в продвижении сайтов разных тематик и отраслей. Очень важно помнить, что клиентский портфель – это не число, озвученное представителем SEO-компании и не количество логотипов на сайте. Честный ответ всегда должен быть подтвержден независимыми рейтингами и внушительным количеством официальных благодарственных писем, подтвержденных подписью и печатью и оформленных, как правило, на официальных бланках.'
        },
        {
          icon: 'IconWallet',
          title: 'Цены на услуги SEO-компании адекватны объему работ',
          text: 'Говоря о стоимости работ, всегда проверяйте, сделан ли расчет в строгом соответствии с Вашим техническим заданием. В большинстве случаев, низкая цена обусловлена заменой дорогих, но эффективных, запросов на дешевые и бесполезные. Если же подрядчик готов работать без абонентской платы, это должно сразу насторожить. Альтруизма в бизнесе не существует. Как правило, Вам придется постоянно доплачивать за каждый следующий вид работ, что в итоге выйдет намного дороже.'
        },
        {
          icon: 'IconMonitor',
          title: 'SEO-компания автоматически продвигает сайты и в ЯНДЕКСе, и в Google',
          text: 'Одновременное продвижение в двух основных поисковых системах – Яндекс и Google – это максимально возможное количество Клиентов на Вашем сайте. Цифры говорят сами за себя: Яндекс (более 57% аудитории Рунета) + Google (более 35%) = 92% целевой аудитории Вашего интернет-ресурса. Нет ни малейшей логики в отказе от одного из сегментов целевой аудитории.'
        },
        {
          icon: 'IconChecklist',
          title: 'SEO-компания работает только по договору',
          text: 'Официальный договор и закрывающие документы по оплатам – важнейшее условие законного сотрудничества, показатель чистоплотности и добропорядочности подрядчика. Любая серьезная организация в нашей отрасли дорожит своим профессиональным имиджем и соблюдает требования законодательства РФ. Такие компании работают только по официальному договору, в котором доступно и логично прописаны права и обязанности сторон, а также приведен подробный план-график работ по проекту и прогнозируемый результат.'
        },
        {
          icon: 'IconCollaboration',
          title: 'SEO-компания имеет собственную Службу качества',
          text: 'Постоянная доступность аккаунт-менеджера и работа независимого подразделения с обращениями Клиентов – верный признак клиентоориентированности компании и ее стремления к повышению уровня удовлетворенности Клиентов. Такая система позволяет SEO-компании оперативно реагировать на изменения спроса, разрабатывать только нужные Клиентам услуги и постоянно повышать качество обслуживания.'
        },
        {
          icon: 'IconCard',
          title: 'SEO-компания готова предложить действенную программу лояльности',
          text: 'Программа привилегий – серьезный бонус, позволяющий Клиентам получать максимальную отдачу от сотрудничества с SEO-компанией. Наличие такой программы говорит, прежде всего, о нацеленности потенциального партнера на долгосрочное взаимовыгодное сотрудничество, поэтому не стоит пренебрегать столь весомым аргументом при выборе подрядчика.'
        },
        {
          icon: 'IconLamp',
          title: 'SEO-компания автоматизирует бизнес-процессы и применяет современные технологии',
          text: 'Интернет-маркетинг, как и любая область современного бизнеса, не стоит на месте. Поисковые системы «придумывают» все более замысловатые алгоритмы, усложняя жизнь как владельцам сайтов, так и SEO-компаниям. Нежелание (или невозможность) развиваться в ногу со временем, применение устаревших методик неизбежно приводит к проблемам и отсутствию результатов. Сегодня ключ к успеху кроется в умелом сочетании высокоэффективных сервисов и развитии собственных технологий с индивидуальным, в полном смысле слова, подходом к Клиенту.'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

h3:before {
  content: '';
  border: 3px solid $borderDangerColor;
  margin-right: 5px;
}

.signs {
  margin: 20px 0;

  & div:last-child {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .sign {
    border-bottom: 1px solid $textGrayColor;
    padding-bottom: 20px;
    margin-bottom: 20px;

    .sign-icon {
      float: left;
      width: 40px;

      svg {
        height: auto;
        width: 30px;
        margin: 5px;
      }
    }

    .sign-content {
      margin-left: 50px;

      .sign-title {
        color: $textDangerColor;
        font-weight: bold;
        font-size: 20px;
        padding-top: 7px;
      }

      .sign-text {

      }
    }
  }
}
</style>
